import React from 'react'
import KnowledgeHubSearch from './search/knowledge-hub'

const searchIndices = [
  { name: `Events`, title: `Upcoming Events`, id: "upcoming" },
  { name: `Events`, title: `Past Events`, id: "past"},
]

export default function EventSearch({ props, location }) {
  const { heading } = props
  return (
    <>
      <section className={`p-section bg-teal-50 event-search`}>
        <div className={`container`}>
          <KnowledgeHubSearch indices={searchIndices} heading={heading} location={location} />
        </div>
      </section>
    </>
  )
}
